import type { ISerialize } from '@/objects/ISerialize';
import { formatDateIso } from '@/utilities/dateutils';

export class ExternalDatasourceEvent implements ISerialize {
    public Date: Date;

    public Key: string | null;

    public Location: string | null;

    public Name: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Date?: Date; Key?: string | null; Location?: string | null; Name?: string | null }) {
        this.Date = values.Date ?? new Date('1970-01-01T00:00:00.000');

        this.Key = values.Key ?? '';

        this.Location = values.Location ?? '';

        this.Name = values.Name ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"Date": ${'"' + formatDateIso(this.Date) + '"'}` +
            ',' +
            `"Key": ${JSON.stringify(this.Key)}` +
            ',' +
            `"Location": ${JSON.stringify(this.Location)}` +
            ',' +
            `"Name": ${JSON.stringify(this.Name)}` +
            '}'
        );
    }

    /**
     * Creates an instance of ExternalDatasourceEvent from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Date?: Date;
        Key?: string | null;
        Location?: string | null;
        Name?: string | null;
    }): ExternalDatasourceEvent {
        return new ExternalDatasourceEvent(values);
    }

    public static _FromServerJson(json: any): ExternalDatasourceEvent {
        return new ExternalDatasourceEvent({
            Date: json.Date instanceof Date ? json.Date : new Date(json.Date),
            Key: json.Key ?? '',
            Location: json.Location ?? '',
            Name: json.Name ?? '',
        });
    }

    /**
     * Creates an instance of ExternalDatasourceEvent from another instance of ExternalDatasourceEvent.
     * @param other The ExternalDatasourceEvent you want to clone
     * @returns A cloned ExternalDatasourceEvent
     */
    public static FromOther(other: ExternalDatasourceEvent): ExternalDatasourceEvent {
        return ExternalDatasourceEvent._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ExternalDatasourceEvent.FromOther(this);
    }

    static NAME_OF_CLASS = 'ExternalDatasourceEvent';
}
